"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
const PartnerNav = function (_ref) {
  let {
    disabled = false
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      textAlign: "center"
    },
    "data-testid": "PartnerNav",
    children: "Legacy Partner Nav is no longer supported. If you're seeing this message, please remove references to this component."
  });
};
var _default = exports.default = PartnerNav;